import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'
import { VersioningStrategy, withVersioning } from 'axios-api-versioning'
import qs from 'qs'

import { 
  fetchCoreApiConfig,
  WCRestAPIConfig,
  WCStoreAPIConfig,
  WPRestAPIConfig,
} from './constants'

class ApiService {
  client: AxiosInstance

  constructor(config: AxiosRequestConfig) {
    const baseClient = axios.create({
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    })

    const client = withVersioning(baseClient, {
      apiVersion: process.env.REACT_APP_API_VERSION,
      versioningStrategy: VersioningStrategy.UrlPath,
    })

    client.interceptors.response.use(this.handleSuccess.bind(this), this.handleError.bind(this))
    this.client = client as unknown as AxiosInstance
  }

  handleSuccess(response: AxiosResponse) {
    return response
  }

  handleError(error: AxiosError) {
    return Promise.reject(error)
  }

  async get<T = any>(url: string, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    const response = await this.client.get<T>(url, config)
    return response
  }

  async post<T = any>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse<T>> {
    const response = await this.client.post<T>(url, data, config)
    return response
  }

  async put<T = any>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse<T>> {
    const response = await this.client.put<T>(url, data, config)
    return response
  }

  async patch<T = any>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse<T>> {
    const response = await this.client.patch<T>(url, data, config)
    return response
  }

  async delete<T = any>(url: string, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    const response = await this.client.delete<T>(url, config)
    return response
  }
}

export const WCStoreAPI = new ApiService(WCStoreAPIConfig)
export const WCRestAPI = new ApiService(WCRestAPIConfig)
export const FetchCoreAPI = new ApiService(fetchCoreApiConfig)
export const WPRestAPI = new ApiService(WPRestAPIConfig)
